import {
  signInAnonymously,
  linkWithCredential,
  EmailAuthProvider,
  updateProfile,
} from "firebase/auth";
import { auth } from "./firebase_component";

/**
 * Start guest (anonymous) session
 */
export const startGuestSession = async () => {
  const userCred = await signInAnonymously(auth);
  return userCred.user;
};

/**
 * Upgrade guest -> registered (Email/Password)
 * UID remains the SAME in Firebase
 */
export const upgradeGuestToUser = async (
  email,
  password,
  fullName,
  phone
) => {
  if (!auth.currentUser) {
    throw new Error("No user signed in");
  }

  if (!auth.currentUser.isAnonymous) {
    throw new Error("Current user is not a guest");
  }

  const olduid = auth.currentUser.uid;

  const credential = EmailAuthProvider.credential(email, password);
  const result = await linkWithCredential(auth.currentUser, credential);

  await updateProfile(result.user, {
    displayName: fullName,
  });

  return {
    olduid,                 // 👈 important for consistency
    uid: result.user.uid,   // SAME as olduid
    FullName: fullName,
    Email: email,
    PhoneNumber: phone,
  };
};
